import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import formacoesStyle from "assets/jss/material-dashboard-pro-react/views/formacoesStyle.jsx";
import connection from "../../connection";
import termosCondicoes from "../../assets/static/TERMOS_E_CONDICOES.pdf";
import general from "../../general";
import SweetAlert from "../SweetAlertWrapper";
import MomentFromNow from "../MomentFromNow";
import Button from "../CustomButtons/Button";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import moment from "moment";

function ConfirmarRegisto(props) {
  const classes = props.classes;
  const acontecimento = props.acontecimento;
  const preco = acontecimento.tipo_acontecimento === 'percurso' ? null : acontecimento.preco_inscricao.toFixed(2).replace(".", ",") + "€";
  const disabled_button = acontecimento.estado.codeTxt !== "REGISTOS_ABERTOS" || (acontecimento.tipo_acontecimento === "curso" && ["IPE", "FGPE", "EMSPIF"].includes(acontecimento.tipo_codigo) && !acontecimento.pode_inscrever_curso_pif) || (acontecimento.tipo_acontecimento === "formacao" ? !acontecimento.pode_inscrever.validacao : false) || !!acontecimento.acontecimento_teste || (acontecimento.limite_inscricoes && (acontecimento.inscritos >= acontecimento.limite_inscricoes));
  const tipo_acontecimento = acontecimento.tipo_acontecimento === "formacao" ? "módulo" : acontecimento.tipo_acontecimento
  let dados = props.dados;
  const [aceitarTermosCondicoes, setAceitarTermosCondicoes] = useState(false);
  const [modal, setModal] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [cancelarRegisto, setCancelarRegisto] = useState(null);
  const [openCancelarRegisto, setOpenCancelarRegisto] = useState(false);

  const refreshModal = async () => {
    setModal(
      <SweetAlert
        style={acontecimento.preco_inscricao > 0 ? {width: "750px"} : {width: "600px"}}
        warning
        title="Confirmar inscrição"
        onConfirm={async () => {
          await connection.post(`${acontecimento.tipo_acontecimento}/participante/inscrever`, dados);
          general.success("Foi inscrito com sucesso, aguarde o fecho dos registos para saber se foi selecionado", "Sucesso!");
          setOpenModal(false);
          setAceitarTermosCondicoes(false);
          props.reloadDetalhes();
        }}
        onCancel={() => {
          setOpenModal(false);
          setAceitarTermosCondicoes(false);
        }}
        confirmBtnCssClass={
          classes.button + " " + classes.primary + (aceitarTermosCondicoes ? "" : " " + classes.disabled)
        }
        cancelBtnCssClass={
          classes.button
        }
        disabled={!aceitarTermosCondicoes}
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <div style={{textAlign: "justify"}} className={classes.confirmarRegistoModal}>
          <h4>Pretende confirmar a sua inscrição no {props.designacao}?</h4>
          <h4>A sua inscrição ficará pendente da disponibilidade de vagas e terá em conta um conjunto de regras de prioridade, nomeadamente a proximidade ao seu agrupamento, núcleo ou região, pagamentos falhados previamente, e a ordem de inscrição.</h4>
          <h4>Após o término do período de registos ({moment(acontecimento.data_limite_registos).format("[a] DD [de] MMMM [de] YYYY" + " [às] HH:mm")}), o diretor/formador irá fazer a validação dos participantes.</h4>
          {preco && acontecimento.preco_inscricao > 0 && <><h4> Caso o seu registo seja aceite, deverá fazer o pagamento no valor de <span style={{fontWeight: 'bold'}}>{preco}</span> (euros) através de um dos métodos de pagamento disponíveis, dentro do prazo definido.</h4>
            <h4 style={{textDecorationLine: 'underline'}}>A falta de pagamento irá libertar a sua vaga para os candidatos em fila de espera.</h4>
            <h4>Métodos de pagamento disponíveis:</h4>
            <div className={"logo-multibanco"}/>
          </>}
          <br/>
          <h4>Para avançar, concorde com os termos e condições:</h4>
          <label className={"texto"} style={{display: "inline-block"}}>
            <input className={"texto"} style={{marginLeft: "0", verticalAlign: "middle"}} type="checkbox" checked={aceitarTermosCondicoes} onChange={() => setAceitarTermosCondicoes(!aceitarTermosCondicoes)}/>
            Concordo com os &nbsp;
          </label>
          <a className={"clickable"} onClick={() => window.open(termosCondicoes)}>
            termos e condições.
          </a>
        </div>
      </SweetAlert>
    )
  }

  const refreshModalCancelar = async () => {
    setCancelarRegisto(
      <SweetAlert
        style={acontecimento.preco_inscricao > 0 ? {width: "750px"} : {width: "600px"}}
        warning
        title="Cancelar inscrição"
        onConfirm={async () => {
          await connection.post(`${acontecimento.tipo_acontecimento}/candidato/anular_inscricao`, {[`${acontecimento.tipo_acontecimento}`]: acontecimento.id});
          general.success("Sua inscrição foi cancelada.", "Sucesso!");
          setOpenCancelarRegisto(false);
          props.reloadDetalhes();
        }}
        onCancel={() => {
          setOpenCancelarRegisto(false);
          setAceitarTermosCondicoes(false);
        }}
        confirmBtnCssClass={
          classes.button + " " + classes.primary
        }
        cancelBtnCssClass={
          classes.button
        }
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <div style={{textAlign: "justify"}} className={classes.confirmarRegistoModal}>
          <h4>Pretende cancelar a sua inscrição no {props.designacao}?</h4>
          <h4>A sua inscrição será cancelada e poderá voltar a se inscrever neste módulo até o término do período de registos ({moment(acontecimento.data_limite_registos).format("[a] DD [de] MMMM [de] YYYY" + " [às] HH:mm")}).</h4>
        </div>
      </SweetAlert>
    )
  }

  useEffect(() => {
    dados.aceitacao = aceitarTermosCondicoes;
    refreshModal();
  }, [openModal, aceitarTermosCondicoes]);


  useEffect(() => {
    refreshModalCancelar();
  }, [openCancelarRegisto]);

  return <>
    {openModal && modal}
    {openCancelarRegisto && cancelarRegisto}
    <Card>
      <CardHeader color="primary">
        <h4 style={{flex: 1}}>Inscrição</h4>
      </CardHeader>
      <CardBody className={classes.courseDetails}><h4>{(() => {
        let registos_fechados = acontecimento.data_limite_registos && new Date(acontecimento.data_limite_registos) <= new Date();
        let registos_finalizados = acontecimento.data_registos_fechados && new Date(acontecimento.data_registos_fechados) <= new Date();

        let texto = null;
        if (acontecimento.registo.selecionado) {
          if (acontecimento.registo.aprovado) {
            if (acontecimento.registo.preco > 0)
              texto = `É agora participante deste ${tipo_acontecimento}.`;
            else
              texto = `Foi selecionado e é agora participante deste ${tipo_acontecimento}.`;
          } else {
            texto = <span>Foi selecionado e deverá efetuar o pagamento <MomentFromNow time={acontecimento.registo.limite_pagamento}/></span>;
          }

        } else if (acontecimento.registo.registado) {
          if (registos_finalizados)
            texto = `Infelizmente não foi selecionado para participar neste ${tipo_acontecimento}. Em caso de dúvidas contacte o formador.`;
          else {
            if (registos_fechados)
              texto = "O registo está a ser revisto.";
            else
              texto = "O seu registo foi efetuado, aguarde pelo fecho dos registos.";
          }
        } else {
          if (acontecimento.data_abertura_registos && new Date(acontecimento.data_abertura_registos) > new Date())
            texto = <span>Os registos serão abertos a {general.Renderers.dateRenderer(acontecimento.data_abertura_registos)}</span>;
          else {
            if (registos_fechados)
              texto = "Os registos estão fechados, não poderá candidatar-se a este módulo. Em caso de dúvidas contacte o formador.";
            else if (acontecimento.tipo_acontecimento === "formacao" && !acontecimento.pode_inscrever.validacao) {
              if (acontecimento.pode_inscrever.formacao)
                texto = <>{acontecimento.pode_inscrever.texto}
                  <br/>
                  <a style={{fontSize: '0.8em'}} className={"clickable"} onClick={() => window.open("/formacao/" + acontecimento.pode_inscrever.formacao)}>
                    #{general.pad(acontecimento.pode_inscrever.formacao, 5)} - {acontecimento.pode_inscrever.modulo_obrigatorio}
                  </a>
                </>
              else if (acontecimento.pode_inscrever.modulos_opcionais)
                texto = <>{acontecimento.pode_inscrever.texto}
                  <br/>
                  <a style={{fontSize: '0.8em'}} className={"clickable"} onClick={() => window.open("/formacao/" + acontecimento.pode_inscrever.formacoes[0])}>
                    #{general.pad(acontecimento.pode_inscrever.formacoes[0], 5)} - {acontecimento.pode_inscrever.modulos_opcionais[0]}
                  </a>
                  <br/>
                  <a style={{fontSize: '0.8em'}} className={"clickable"} onClick={() => window.open("/formacao/" + acontecimento.pode_inscrever.formacoes[1])}>
                    #{general.pad(acontecimento.pode_inscrever.formacoes[1], 5)} - {acontecimento.pode_inscrever.modulos_opcionais[1]}
                  </a>
                </>
            } else
              texto = <span>Poderá fazer o registo até {general.Renderers.dateRenderer(acontecimento.data_limite_registos)}</span>;
          }
        }
        return texto;
      })()}</h4>
        {!acontecimento.registo.registado ? <><Button disabled={disabled_button} className={classes.button + " " + classes.info + " " + classes.block} size="sm" onClick={() => {
          //Popup de confirmação de registo
          setOpenModal(true);
        }}> Registar ({preco})
        </Button>
          {!disabled_button && acontecimento.preco_inscricao > 0 && <><small>Métodos de pagamento disponíveis:</small>
            <div className={"logo-multibanco"}/>
          </>}
        </> : (!acontecimento.registo.nao_selecionado && !acontecimento.registo.selecionado ? <Button className={classes.button + " " + classes.info + " " + classes.block} size="sm" onClick={() => {
          //Popup para cancelar o registo
          setOpenCancelarRegisto(true);
        }}> Cancelar registo
        </Button> : null)}
      </CardBody>
    </Card>
  </>
}

ConfirmarRegisto.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool
};

export default withStyles(formacoesStyle)(ConfirmarRegisto);
